import React, {Fragment, useEffect, useState} from 'react';
import axios from 'axios';
import { useParams} from "react-router-dom";
import OpenPositions from "../components/OpenPositions";
import {API_BASE_URL} from "../config";
import '../assets/css/Position.css'
import Tasks from "../components/Tasks";
import ClosedPositions from "../components/ClosedPositions";
import ClientCard from "../components/ClientCard";
import PositionTimingInfo from "../components/PositionTimingInfo";
import AdditionalTask from "../components/AdditionalTask";
import ReactQuill from "react-quill-new";
import Button from "../components/Elements/Button";
import {toast, ToastContainer} from "react-toastify";
import {cleanString} from "../utils/textUtils";

const PositionDetail = () => {
    const {position_id} = useParams(); // Extract order_id from URL params
    const [position, setPosition] = useState([]);
    const [positionNote, setPositionNote] = useState('');
    const [finishedTasks, setFinishedTasks] = useState([])
    const [inProgressTasks, setInProgressTasks] = useState([]);
    const [isOpenProgressTask, setIsOpenProgressTask] = useState(true);
    const [isOpenFinishedTask, setIsOpenFinishedTask] = useState(false);
    const [isOpenOpenPositions, setIsOpenOpenPositions] = useState(false);
    const [isOpenClosedPositions, setIsOpenClosedPositions] = useState(false);
    const [isOpenInfo, setIsOpenInfo] = useState(false);
    const [totalTimeSpent, setTotalTimeSpent] = useState('');
    const [totalEstimatedPerTasksFinished, setTotalEstimatedPerTasksFinished] = useState('');
    const [totalEstimatedTime, setTotalEstimatedTime] = useState('');
    const [totalRemainingEstimatedTime, setTotalRemainingEstimatedTime] = useState('');
    const [showAdditionalTasks, setShowAdditionalTasks] = useState(false)
    const [buttonLabel, setButtonLabel] = useState('Enregistrer')
    const [version, setVersion] = useState(0);
    const refreshTasks = () => setVersion(v => v + 1);

    const formatDate = (isoDate) => {
        const date = new Date(isoDate); // Create a Date object from the ISO string
        const day = String(date.getUTCDate()).padStart(2, '0'); // Get the day and pad with leading zero
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Get the month (0-11, hence +1) and pad
        const year = date.getUTCFullYear(); // Get the full year
        return `${day}/${month}/${year}`; // Return in the format DD/MM/YYYY
    };

    const changePositionNote = (value) => {
        setPositionNote(value)
        setButtonLabel('Enregistrer')
    }

    const toggleOpenInfo = () => {
        setIsOpenInfo(!isOpenInfo);
    };

    const toggleOpenPositions = () => {
        setIsOpenOpenPositions(!isOpenOpenPositions);
    };

    const toggleClosedPositions = () => {
        setIsOpenClosedPositions(!isOpenClosedPositions);
    };
    const toggleIsOpenProgressTask = () => {
        setIsOpenProgressTask(!isOpenProgressTask);
    };
    const toggleIsOpenFinishedTask = () => {
        console.log(isOpenFinishedTask)
        setIsOpenFinishedTask(!isOpenFinishedTask);
    };

    useEffect(() => {

        console.log(position_id)

        //console.log(localStorage)
        axios.post(`${API_BASE_URL}/get_position/${position_id}`)
            .then(response => {
                console.log(response);
                const {data} = response;
                if (data.status === 'ok') {
                    console.log(data);

                    console.log(data.datas)
                    setPosition(data.datas);
                    setPositionNote(data.datas[0]?.production_note); // Optional chaining in case datas is empty

                    if (data.datas[0].progress === 100) {
                        if (data.datas[0].article_id === 300 || data.datas[0].article_id === 312 || data.datas[0].article_id === 313 || data.datas[0].article_id === 314 || data.datas[0].article_id === 358) {
                            setShowAdditionalTasks(true)
                        }
                    }

                    document.title = `${data.datas[0]?.name_1} | ${data.datas[0]?.name_1}`
                } else {
                    console.error('Error fetching position details:', data.message);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, [position_id]); // Fetch data when order_id changes

    useEffect(() => {

        refreshTasks()
    }, [position_id])


    useEffect(() => {

        axios.post(`${API_BASE_URL}/get_all_tasks`, { positionId: position_id })
            .then(res => {

                const tasks = res?.data?.datas || [];
                if (!Array.isArray(tasks)) return;

                setFinishedTasks(tasks.filter(t => parseInt(t.progress, 10) === 100));
                setInProgressTasks(tasks.filter(t => parseInt(t.progress, 10) < 100));
            })
            .catch(err => console.error('Error fetching tasks:', err));

    }, [position_id, position, version]);


    const fetchTasks = () => {
        axios
            .post(`${API_BASE_URL}/get_all_tasks`, { positionId: position_id })
            .then((res) => {
                const tasks = res?.data?.datas || [];

                // ⚠️ évite l’erreur si datas est undefined
                console.log(Array.isArray(res?.data?.datas) ? res.data.datas.length : 0);

                if (!Array.isArray(tasks)) {
                    console.error('Tasks is not an array:', tasks);
                    return;
                }

                // Accumulateurs
                let totalEstimatedTime = 0;
                let totalTimeSpentInMinutes = 0;
                let totalEstimatedForFinishedTasks = 0;

                tasks.forEach((task) => {
                    totalEstimatedTime += task.estimated_duration || 0;

                    if (task.time_spent && task.time_spent !== '00:00:00') {
                        const [hours, minutes] = task.time_spent.split(':').map(Number);
                        totalTimeSpentInMinutes += (hours * 60) + minutes;
                    }

                    if (parseInt(task.progress, 10) === 100) {
                        totalEstimatedForFinishedTasks += task.estimated_duration || 0;
                    }
                });

                const totalEstimatedTimeRemaining = totalEstimatedTime - totalEstimatedForFinishedTasks;
                const formatTime = (minutes) => {
                    const hours = Math.floor(minutes / 60);
                    const remainingMinutes = minutes % 60;
                    return `${String(hours).padStart(2, '0')}:${String(remainingMinutes).padStart(2, '0')}`;
                };

                setTotalEstimatedTime(formatTime(totalEstimatedTime));
                setTotalRemainingEstimatedTime(formatTime(totalEstimatedTimeRemaining));
                setTotalEstimatedPerTasksFinished(formatTime(totalEstimatedForFinishedTasks));
                setTotalTimeSpent(formatTime(totalTimeSpentInMinutes));

                const finishedTasks = tasks.filter((t) => parseInt(t.progress, 10) === 100);
                const inProgressTasks = tasks.filter((t) => parseInt(t.progress, 10) < 100);
                setFinishedTasks(finishedTasks);
                setInProgressTasks(inProgressTasks);
            })
            .catch((error) => console.error('Error fetching tasks:', error));

    };
    useEffect(() => {

        fetchTasks()

    }, [position_id, position]); // se relance seulement quand la position ou l’order_id change

    const handleSave = () => {
        toast.success("Position sauvegardée")
    }

    const handleCommentSection = () => {

        const currentUrl = window.location.href;
        const positionId = currentUrl.split('/').pop();

        // Assuming you have an API endpoint to update the position note
        axios.post(`${API_BASE_URL}/update_position_note`, {
            note: positionNote, id: positionId
        })
            .then((response, err) => {
            const {data} = response;

            if (data.status === 200) {
                toast.success("Note enregistrée !")
            } else {
                toast.error("Une erreur est survenue lors de l'enregistrement, merci de vérifier votre connexion Internet et réessayer.")
            }
        })
    };
    const deleteTasks = () => {
        const currentUrl = window.location.href;
        const positionId = currentUrl.split('/').pop();

        const res = window.confirm("Voulez-vous vraiment supprimer toutes les tâches en cours ? Cela n'impactera pas les tâches déjà terminées.");

        if (res) {
            if (!positionId || isNaN(positionId)) {
                throw new Error('Invalid position ID in URL');
            }

            axios.post(`${API_BASE_URL}/delete_position_tasks`, {id: positionId})
                .then(() => {
                    fetchTasks();
                })
                .catch(error => {
                    console.error('Error fetching default tasks:', error);
                });
        }
    }

    // Fetch tasks when component mounts
    useEffect(() => {
        fetchTasks();
    }, [ position]); // Fetch tasks when the position changes


    const createDefaultTasks = () => {

        const currentUrl = window.location.href;
        const positionId = currentUrl.split('/').pop();

        if (!positionId || isNaN(positionId)) {
            throw new Error('Invalid position ID in URL');
        }

        axios.post(`${API_BASE_URL}/get_default_tasks`, {positionId})
            .then(response => {
                const defaultTasks = response.data.default_tasks;

                if (defaultTasks.length > 0) {
                    const tasksArray = defaultTasks.map(task => task.id);

                    console.log(tasksArray)

                    axios.post(`${API_BASE_URL}/set_default_tasks`, {tasks: tasksArray, positionId})
                        .then(() => {
                            // Fetch updated tasks after creating default tasks
                            fetchTasks();
                        })
                        .catch(error => {
                            console.error('Error creating tasks:', error);
                        });
                } else {
                    console.log('No default tasks found.');
                }
            })
            .catch(error => {
                toast.error(`Aucune tâche n'a été trouvée pour ce type d'article.`);
                console.error('Error fetching default tasks:', error);
            });

    };

    return (<Fragment>
        {position.map((position) => (<Fragment>
                <ToastContainer position="bottom-right" autoClose={3000} />

                {position.is_archived === 1 && <div>
                    <span className={"archived-div"}><p>🗑️ Attention, ce projet est archivé</p></span></div>}
                {position.progress === 100 && <div>
                        <span
                            className={"finished-div p-20 text-center"}><p>🎉 Ce projet a été terminé le {formatDate(position.end_date ? position.end_date : position.updated_at)}.</p></span>
                </div>}
                <div key={position.id}>
                    <div>
                        <h1 className={"h1-position-title"} dangerouslySetInnerHTML={{__html: position.name_1}}/>

                        <span className={"text-primary position-id-text"}>{position.order_id} - </span>
                        <span className={"text-primary position-id-text"}>{(cleanString( position.text || position.title) )}</span><br/>
                        <hr/>
                        <div className={"position-container"}>

                            <div className={"flexwrap-wrap w-100"}
                                 style={{
                                     display: "flex",
                                     justifyContent: localStorage.user_role === 'Administrateur' ? "space-between" : "initial"
                                 }}>

                                <div style={{padding: "20px 0"}}
                                     className={"display-flex gap-20 w-100 container-position-buttons-time"}>

                                    <Fragment>
                                        <div className={"display-flex flex-direction-column "}>
                                            <div
                                                className={'gap-10 display-flex inline-buttons justify-content-space-evenly h-100'}>
                                                <button
                                                    className={"no-bg  display-flex align-items-center w-100 p-0 cursor-pointer"}
                                                    onClick={() => createDefaultTasks(position)}>
                                                    <span
                                                        style={{
                                                            backgroundColor: "rgb(72, 159, 68)",
                                                            borderRadius: "5px 0px 0 5px"
                                                        }}
                                                        className={"display-flex flex-direction-row h-100 align-items-center "}>

                                                    <i className="fa-regular fa-plus pl-10 color-white"></i>
                                                    <div className={"v-separator m-10 mr-0"}
                                                         style={{backgroundColor: "white"}}/>
                                                    </span>
                                                    <span
                                                        className={"create-task p-0 button-action w-100 h-100 display-flex text-left"}>
                                                    <span className={"p-10 "}>Créer les tâches par défaut</span>
                                                    </span>
                                                </button>

                                                <button
                                                    className={"no-bg display-flex align-items-center w-100 p-0 cursor-pointer"}
                                                    onClick={() => deleteTasks(position)}>
                                                    <span
                                                        style={{
                                                            backgroundColor: "orangered", borderRadius: "5px 0px 0 5px"
                                                        }}
                                                        className={"display-flex flex-direction-row h-100 align-items-center "}>

                                                    <i className="fa-regular fa-trash-can pl-10 color-white"></i>
                                                    <div className={"v-separator m-10 mr-0"}
                                                         style={{backgroundColor: "white"}}/>
                                                    </span>
                                                    <span
                                                        className={"delete p-0 button-action w-100 h-100 display-flex align-center"}>
                                                    <span className={"p-10 "}>Supprimer toutes les tâches</span>
                                                    </span>
                                                </button>

                                                <button
                                                    className={"no-bg bg-third display-flex align-items-center w-100 p-0 cursor-pointer"}
                                                    style={{borderRadius: 8}}
                                                    onClick={() => window.location.href = (`/client/${position.contact_id}`)}
                                                >

                                                    <span
                                                        style={{
                                                            backgroundColor: "var(--third)",
                                                            borderRadius: "5px 0px 0 5px"
                                                        }}
                                                        className={"display-flex flex-direction-row h-100 align-items-center "}>

                                                    <i className="fa-regular fa-external-link pl-10 color-white"
                                                       style={{fontSize: "12.6px"}}></i>
                                                    <div className={"v-separator m-10 mr-0"}
                                                         style={{backgroundColor: "white"}}/>
                                                    </span>
                                                    <span
                                                        className={"see-customer p-0 button-action w-100 h-100 display-flex align-center"}>
                                                    <span className={"p-10"}>Voir la fiche client</span>
                                                    </span>
                                                </button>
                                                <button
                                                    className={"no-bg  display-flex align-items-center w-100 p-0 cursor-pointer"}
                                                    onClick={handleSave}>
                                                    <span
                                                        style={{
                                                            backgroundColor: "#03a1d5", borderRadius: "5px 0px 0 5px"
                                                        }}
                                                        className={"display-flex flex-direction-row h-100 align-items-center "}>

                                                    <i className="fa-regular fa-floppy-disk pl-10 color-white"></i>
                                                    <div className={"v-separator m-10 mr-0"}
                                                         style={{backgroundColor: "white"}}/>
                                                    </span>
                                                    <span
                                                        className={"save p-0 button-action w-100 h-100 display-flex align-center"}>
                                                    <span className={"p-10 "}>Sauvegarder</span>
                                                    </span>
                                                </button>

                                            </div>


                                        </div>

                                         <PositionTimingInfo data={{
                                            totalTimeSpent: totalTimeSpent,
                                            totalRemainingEstimatedTime: totalRemainingEstimatedTime,
                                            totalEstimatedTime: totalEstimatedTime,
                                            totalEstimatedPerTasksFinished: totalEstimatedPerTasksFinished
                                        }}/>

                                    </Fragment>
                                </div>


                            </div>

                            <div className={"display-flex container-position "}>
                                <div>
                                    <div className={"position-container left container-positions flex-1 pr-20"}
                                         style={{height: "fit-content"}}>

                                        <div className={"flex border-radius-10"}>
                                            <ClientCard client={position} displayButtonFiche={true}
                                                        headClasses={"border-221-1px border-radius-10 hover-lightgray no-radius-bottom border-bottom-none"}
                                                        contentClasses={"border-radius-10 no-radius-top border-solid-1px border-color-ddd no-border-top"}/>
                                        </div>
                                        <div className={"position-component mb-20 no-bg"}>
                                            <div
                                                className={`border-221-1px display-flex gap-20 color-third p-20 bg-eee border-radius-10 hover-lightgray cursor-pointer ${isOpenInfo ? 'no-radius-bottom' : ''}`}
                                                onClick={toggleOpenInfo}>
                                                <h3 className={"title-positions-menus color-third"}>
                                                    <i className="fa-solid fa-circle-info"
                                                       style={{marginRight: "10px"}}></i>
                                                    Informations générales
                                                </h3>
                                                <i
                                                    className={`display-flex align-items-center fa-solid fa-chevron-down arrow-icon ${isOpenInfo ? 'rotate' : ''}`}
                                                    style={{marginLeft: "10px"}}
                                                ></i>
                                            </div>
                                            {isOpenInfo && (<div
                                                className={"p-0 flex no-radius-top no-border-top display-flex flex-direction-column"}
                                                style={{borderColor: "#ddd"}}>

                                                <ReactQuill
                                                    className=" m-0 no-outline no-border h-100 "
                                                    id="position_note"
                                                    style={{marginTop: 20, maxWidth: 400}}
                                                    onChange={(value)=>changePositionNote(value)}
                                                    value={positionNote}
                                                />

                                                <div className={"p-15 bg-white"}>

                                                    <Button onClick={handleCommentSection} iconBackground={'bg-fifth'}
                                                            icon={'fa-floppy-disk'} label={buttonLabel} textClassNames={buttonLabel === 'Enregistré !' ? 'bg-primary' : 'bg-third btn-save'}
                                                            iconClasseNames={'color-white'} disableLink={true}  />
                                                </div>
                                            </div>)}
                                        </div>
                                        <div className={"position-component mb-20 no-bg"}>
                                            <div
                                                className={`border-221-1px display-flex gap-20 color-third p-20 bg-eee border-radius-10 hover-lightgray cursor-pointer ${isOpenOpenPositions ? 'no-radius-bottom' : ''}`}
                                                onClick={toggleOpenPositions}>
                                                <h3 className={"title-positions-menus color-third"}>

                                                    <i className="fa-solid fa-list" style={{marginRight: "10px"}}></i>
                                                    Autres projets en cours
                                                </h3>
                                                <i
                                                    className={`display-flex align-items-center fa-solid fa-chevron-down arrow-icon ${isOpenOpenPositions ? 'rotate' : ''}`}
                                                    style={{marginLeft: "10px"}}
                                                ></i>
                                            </div>
                                            {isOpenOpenPositions && <OpenPositions id={position}/>}
                                        </div>

                                        <div className={"position-component no-bg"}>
                                            <div
                                                className={`display-flex border-221-1px gap-20 color-third p-20 bg-eee border-radius-10 hover-lightgray cursor-pointer ${isOpenClosedPositions ? 'no-radius-bottom' : ''}`}
                                                onClick={toggleClosedPositions}>

                                                <h3 className={"title-positions-menus color-third"}>
                                                    <i className="fa-solid fa-check mr-10"/>Autres projets terminés
                                                </h3>
                                                <i
                                                    className={`display-flex align-items-center fa-solid fa-chevron-down arrow-icon ${isOpenClosedPositions ? 'rotate' : ''}`}/>
                                            </div>
                                            {isOpenClosedPositions && <ClosedPositions id={position}/>}
                                        </div>

                                    </div>
                                </div>
                                <div className={"display-flex flex-direction-column flex-3 overflow-auto border-radius-10"}>


                                    <div
                                        className={"display-flex flex-direction-column overflow-auto border-radius-10 mb-20 border-solid-1px border-color-ddd border-radius-10 bg-eee"}>
                                        <div
                                            className="color-third toggle-button display-flex  gap-20 color-third p-20 hover-lightgray no-radius-bottom justify-content-space-between bg-eee"
                                            onClick={() => toggleIsOpenProgressTask()}><h3
                                            className={"color-third m-0 top-0"}>Tâches en cours
                                            ({inProgressTasks.length}/{inProgressTasks.length + finishedTasks.length})</h3>
                                            <i
                                                className={`display-flex align-items-center fa-solid fa-chevron-down arrow-icon ${isOpenProgressTask ? 'rotate' : ''}`}
                                                style={{marginLeft: "10px"}}
                                            ></i>
                                        </div>

                                        <div className={isOpenProgressTask ? "border-solid-1px-top border-color-ddd" : ""}>
                                            <div className={"position-component overflow-auto"}>


                                                {(isOpenProgressTask) && <Tasks
                                                    searchBar={false}
                                                    title={null}
                                                    tasks={inProgressTasks}
                                                    headers={['', '', 'Nom de la tâche', 'Durée estimée', 'Durée passée', 'Date de réalisation', 'Terminé le', 'Personne en charge']}
                                                    headersData={['checkbox', 'progress', 'title_open_position', 'estimated_duration', 'time_spent', 'finish_date_custom', 'finish_date', 'username']}
                                                />}
                                                {/* Tâches aditionnelles si le projet ne contient pas suffisamment de tâches par défaut (typiquement les renouvellements, les service packs, les posts premium etc */}
                                                {showAdditionalTasks && <AdditionalTask position={position} update={refreshTasks}/>

                                            }

                                            </div>

                                        </div>
                                    </div>


                                    <div
                                        className={"display-flex flex-direction-column overflow-auto border-radius-10 border-solid-1px border-color-ddd border-radius-10 bg-eee"}>

                                        <div
                                            className="color-third toggle-button display-flex  gap-20 color-third p-20 bg-eee hover-lightgray no-radius-bottom justify-content-space-between"
                                            onClick={() => toggleIsOpenFinishedTask()}><h3
                                            className={"color-third m-0 top-0"}>Tâches terminées
                                            ({finishedTasks.length}/{inProgressTasks.length + finishedTasks.length})</h3>
                                            <i
                                                className={`display-flex align-items-center fa-solid fa-chevron-down arrow-icon ${isOpenFinishedTask ? 'rotate' : ''}`}
                                                style={{marginLeft: "10px"}}
                                            ></i>
                                        </div>
                                        <div
                                            className={isOpenFinishedTask ? "border-solid-1px-top border-color-ddd" : ""}>
                                            <div className={"position-component overflow-auto"}>
                                                {(isOpenFinishedTask) && (<Tasks
                                                    searchBar={false}
                                                    title={null}
                                                    tasks={finishedTasks}
                                                    headers={['', 'Nom de la tâche', 'Durée estimée', 'Durée passée', 'Terminé le', 'Personne en charge']}
                                                    headersData={["edit", 'title_open_position', 'estimated_duration', 'time_spent', 'finished_at', 'username_ended']}
                                                />)}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        ))}
    </Fragment>);
};

export default PositionDetail;
